import { useTheme } from '@mui/material/styles';
import {grey} from "@mui/material/colors";

export const LayoutPageStyles = () => {
  const theme = useTheme();

  return {
    '& main': {
      background: "#ffffff",
      minHeight: 'calc(100vh - 132px)',
    },
    '& .Main__top-content': {
      background: `${theme.palette.purpleCold.light}`,
      marginBottom: '30px',
      padding: '16px 0',
      minHeight: '40px',
      position: "sticky",
      top: 0,
      zIndex: 3,
    },
    '& .Main__content': {
      marginTop: "32px",
    },
    '& aside': {
      padding: {
        xs: '16px 16px 0',
        md: '16px 0',
      },
    },
    '& .highcharts-credits': {
      visibility: 'hidden',
    },
    '& .info-icon': {
      color: theme.palette.primary.light,
      cursor: "auto",
      fontWeight: 'bold',
      fontSize: '14px',
    },
    '#label-tooltip': {
      background: '#000',
      borderRadius: '4px',
      fontSize: '11px',
      color: '#fff',
      padding: '10px',
      position: 'absolute',
    },
    '.tooltip-desc': {
      background: '#000',
      borderRadius: '4px',
      display: 'block',
      color: '#fff',
      fontSize: '11px',
      fontWeight: 'normal',
      maxWidth: {
        xs: '260px',
        md: '320px',
      },
      padding: '10px',
      position: 'absolute',
      width: 'max-content',
      whiteSpace: "break-spaces",
      zIndex: 1,
    },
    // Style to avoid cut tooltip visibility.
    '.highcharts-legend-item > span': {
      overflow: "visible !important",
    },
    '& .top-toggle': {
      background: "none",
      display: 'flex',
      position: 'absolute',
      top: "7px",
      width: "calc(100% - 80px)",
      left: "20px",
    },
    '& .top-toggle.active': {
      borderBottom: `1px solid rgba(119, 61, 189, 0.5)`,
    },
    '& .bnt-top-toggle': {
      background: theme.palette.purpleCold.light,
      border: `1px solid rgba(119, 61, 189, 0.5)`,
      borderBottomColor: "transparent",
      marginLeft: "16px",
      marginBottom: "-2px",
    },
    '& .bnt-top-toggle.active': {
      color: theme.palette.primary.main,
    },
    '& .bnt-top-toggle svg': {
      color: theme.palette.primary.light,
    },
    '& .bnt-top-toggle.active svg': {
      color: theme.palette.primary.main,
    },
    '& .sticky-menu': {
      paddingTop: "38px"
    },
    '& .highcharts-data-table': {
      margin: "auto",
      padding: "20px 0"
    },
    '& .highcharts-data-table table': {
      width: "90%",
      maxWidth: 680,
      border: `1px solid ${grey[300]}`,
      margin: "0 auto",
      textAlign: "left",
      color: "initial",
    },
    '& .highcharts-data-table tbody th, & .highcharts-data-table tbody td': {
      textAlign: "left",
      padding: "0 10px",
    },
    '& .highcharts-data-table thead': {
      background: grey[300],
      textAlign: "center"
    }
  }
}
